<nz-modal
  nzTitle="Documents"
  nzClosable="true"
  nzWidth="1088px"
  nzMaskClosable="false"
  nzWrapClassName="edit-line-item-modal-container vertical-center-modal"
  [nzVisible]="isModalOpen"
  (nzOnCancel)="closeModal()"
  [nzFooter]="null"
>
<ng-container *nzModalContent>
  <div class="filters-container">
    <app-research-date-filter
      (startDateSelected)="startDate = $event"
      (endDateSelected)="endDate = $event"
    ></app-research-date-filter>
    <div class="primary-ticker-toggle-icon">
      <span>Primary Ticker</span>
      <span class="toggle">
        <nz-switch
          (ngModelChange)="handlePrimaryTickerChange($event)"
          [(ngModel)]="primaryTickerValue"
          [nzCheckedChildren]="checkedTemplate"
        ></nz-switch>
      </span>
    </div>
    <div class="checkboxes-container">
      <label
        nz-checkbox
        (ngModelChange)="handleResearchCheckboxChange($event)"
        [(ngModel)]="researchCheckboxValue"
        class="checkbox-content"
        [nzDisabled]="!access.has_research_access"
        >Research</label
      >
      <label
        nz-checkbox
        (ngModelChange)="handleModelCheckboxChange($event)"
        [(ngModel)]="modelCheckboxValue"
        class="checkbox-content"
        [nzDisabled]="!access.has_model_access"
        >Models</label
      >
      <label
        nz-checkbox
        (ngModelChange)="handleFilingCheckboxChange($event)"
        [(ngModel)]="filingCheckboxValue"
        class="checkbox-content"
        [nzDisabled]="!access.has_filings_access"
        >Filings</label
      >
    </div>
  </div>
  <app-tpr-document-grid
    [startDate]="startDate"
    [endDate]="endDate"
    [primaryTickerValue]="primaryTickerValue"
    [researchCheckboxValue]="researchCheckboxValue"
    [modelCheckboxValue]="modelCheckboxValue"
    [filingCheckboxValue]="filingCheckboxValue"
    [companyId]="companyId"
    [sourceId]="sourceId"
    [ticker]="ticker"
    (hasAccessEvent)="setAccess($event)"
  ></app-tpr-document-grid>
 </ng-container>
</nz-modal>
<ng-template #checkedTemplate><span nz-icon nzType="check"></span></ng-template>
